import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const TaxesIncludedInPrice = (props) => {
  const { cartOrOrder } = props;

  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { taxes } = cartOrOrder;

  if (!taxes) {
    return null;
  }

  const taxInclude = taxes.filter((tax) => tax.isIncludedInPrice === true);
  return (
    <>
      {taxInclude.map((tax) => (
        <div className="c7-order-summary__item--notes" key={tax.id}>
          <div className="c7-order-summary__title">
            {tax.title} {t('checkout.general.included')}
          </div>
          <div className="c7-order-summary__value">
            {currencyFormat(tax.price, currency)}
          </div>
        </div>
      ))}
    </>
  );
};

export default TaxesIncludedInPrice;
